module.exports = __webpack_public_path__ + "img/mind_skeleton_time_1.5c78f04d.png";